import { Route, Switch } from "wouter";
import Community from "./pages/Community";
import Home from "./pages/Home";
import Whitelist from "./pages/Whitelist";

function NotFound() {
  return <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}><div><h1>Page introuvable</h1><a href="/">Revenir à Monyra</a></div></main>;
}

export default function App() {
  return <Switch>
    <Route path="/" component={Home} />
    <Route path="/communaute" component={Community} />
    <Route path="/whitelist" component={Whitelist} />
    <Route component={NotFound} />
  </Switch>;
}
